import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { useEffect } from 'react';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const WishesComeTrue2026 = ({hibisId, scAnswer}) => {

  useEffect(() => {
    const idMap = {
      a: 'id_nl_interes_1',
      b: 'id_nl_interes_2',
      c: 'id_nl_interes_3',
      d: 'id_nl_interes_4',
      e: 'id_nl_interes_5',
      f: 'id_nl_interes_6'
    };

    const normalized = scAnswer?.toLowerCase();
    if (!normalized || !idMap[normalized]) return;

    let retries = 0;
    const maxRetries = 10;

    const tryCheck = () => {
      const el = document.getElementById(idMap[normalized]);
      if (el) {
        el.checked = true;
      } else if (retries < maxRetries) {
        retries++;
        setTimeout(tryCheck, 300);
      } else {
        console.warn('Checkbox not found after max retries');
      }
    };

    tryCheck();
  }, [scAnswer]);

  return (
    <>
      <Header />
      <Hero image="Addiko-wish-for-2026.jpg" xPos="63%" yPos="28%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Hvala, ker ste z nami delili svojo željo.</h1>
                    <p className="text-left">
                      Povedali ste nam, kaj vam trenutno največ pomeni – in to veliko pomeni tudi nam. Vsak cilj je drugačen, zato verjamemo, da mora biti tudi pot do njega prilagojena vam.
                    </p>
                    <p className="text-left">
                      Če želite preveriti, kako vam lahko pomagamo pri uresničitvi vaše želje, izpolnite spodnji obrazec. Naš svetovalec vas bo poklical, odgovoril na mogoča vprašanja in vam pomagal najti rešitev, ki najbolje podpira vaše želje.
                    </p>
                    <p className="text-left">
                      Brez zapletov, brez obiska banke in v svojem tempu.
                    </p>
                    <p className="text-left">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        <b>Addiko banka</b>
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="0e92121d-b218-4d22-b2f3-1dd105c1119b" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}